/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbLocalGridDto
 */
export interface FcbLocalGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbLocalGridDto
     */
    idlocal?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbLocalGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbLocalGridDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbLocalGridDto
     */
    idcentre?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbLocalGridDto
     */
    centre?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbLocalGridDto
     */
    idlieu?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbLocalGridDto
     */
    lieu?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbLocalGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbLocalGridDto interface.
 */
export function instanceOfFcbLocalGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbLocalGridDtoFromJSON(json: any): FcbLocalGridDto {
    return FcbLocalGridDtoFromJSONTyped(json, false);
}

export function FcbLocalGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbLocalGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlocal': !exists(json, 'idlocal') ? undefined : json['idlocal'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
        'idlieu': !exists(json, 'idlieu') ? undefined : json['idlieu'],
        'lieu': !exists(json, 'lieu') ? undefined : json['lieu'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbLocalGridDtoToJSON(value?: FcbLocalGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlocal': value.idlocal,
        'code': value.code,
        'description': value.description,
        'idcentre': value.idcentre,
        'centre': value.centre,
        'idlieu': value.idlieu,
        'lieu': value.lieu,
        'actif': value.actif,
    };
}

